import moment, { Moment } from "moment-timezone";

import { PeriodDate } from "./types";

// End of current month
function getDefaultPeriodEndDate(): PeriodDate {
    return toPeriodDate(moment().endOf("month"));
}

// Start of end month
function getDefaultPeriodStartDate(periodEndDate: PeriodDate): PeriodDate {
    return toPeriodDate(
        moment([
            periodEndDate.year,
            periodEndDate.month - 1,
            periodEndDate.day,
        ]).startOf("month")
    );
}

function toPeriodDate(date: Moment): PeriodDate {
    return {
        year: date.year(),
        month: date.month() + 1,
        day: date.date(),
    };
}

function toStartDate(date: Moment) {
    const startDate = moment(date);
    startDate.set("hour", 0);
    startDate.set("minute", 0);
    startDate.set("second", 0);
    startDate.set("millisecond", 0);
    return startDate;
}

function toEndDate(date: Moment) {
    const endDate = moment(date);
    endDate.set("hour", 23);
    endDate.set("minute", 59);
    endDate.set("second", 59);
    endDate.set("millisecond", 999);
    return endDate;
}

export {
    toPeriodDate,
    getDefaultPeriodEndDate,
    getDefaultPeriodStartDate,
    toEndDate,
    toStartDate,
};
